import { Component, OnInit } from '@angular/core';
import {  Role, LoginUser } from '../_models';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalDataService } from '../_shared';
import { AdminService } from '../_services/admin.service';
import { environment } from '../../environments/environment';
import { AuthService } from '../_services';
@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  currentUser: LoginUser = new LoginUser;
  userFromApi: LoginUser = new LoginUser;
  loading = false;
  submitted = false;
  returnUrl!: string;
  error = '';
  flgLock : boolean =false;
  isProd: boolean = false;
  ProvisioningID!: string;
  routeName: string ="";
  constructor(
    private adminService :AdminService,
    private route: ActivatedRoute,
    private router: Router,
    private gd: GlobalDataService,
    private authService: AuthService
  ) {

  }

  ngOnInit() {
     
     this.isProd=  environment.production 
    this.userFromApi = this.gd.getUserData();
   
    if(this.userFromApi.Role == Role.User) 
    {
      this.adminService.checkComplianceDetails().subscribe(data=>{
        this.flgLock = data;
        this.gd.CheckVOWD(this.flgLock);
      });
    }
    else{
      this.gd.CheckVOWD(this.flgLock );
    }
  }

 

  submit(){
    this.route.params.subscribe((x: any) => {
      let value = this.router.url.split('/').filter((x: any) => x != '');
      if (value.length > 0) {
        this.routeName = value[0];
      }
    });
    this.authService.authDetails(this.ProvisioningID)
    .subscribe(data=> {
      this.currentUser = data;
      this.gd.setUserData(this.currentUser);

      if(this.currentUser){
        localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
        this.ngOnInit();
       }
       else{
          localStorage.setItem('currentUser', JSON.stringify(undefined));
    
        
       }
    });
    localStorage.setItem('currentUser', JSON.stringify(undefined));

    if(this.currentUser==undefined){this.router.navigate(['AMS_UI/NotFound']);}
  }
}
